<template>
  <div>
   <el-card class="box-card" style="padding-bottom: 20px;height: 85%;">
    <div slot="header" class="clearfix" style="text-align:left;">
      <a style="text-decoration:none;color:#337ab7;cursor:pointer;" @click="returnBack">返回</a>
      <span style="line-height: 36px;margin-left:780px;font-weight:bold;">个人中心</span>
    </div>
    <div>
      <p>
          <span class="d_left">登录账号：</span>
          <span>{{loginAcc}}</span>
      </p>
       <p>
          <span class="d_left">联系人姓名：</span>
          <span>{{linkName}}</span>
      </p>
    
      <div style="margin-top:20px;">
          <el-button type="danger" @click="changePwd">修改密码</el-button>
      </div>
    </div>
   </el-card>
   <pu-edit-pwd :add-show="editPwdShow" :link-id="linkId" @closeEditPwd="closeEditPwd"></pu-edit-pwd>
  </div>
</template>
<script>
    import $axios from '../../https/config'
    import puEditPwd from '../deviceMgr/editPoPwd'

    export default {
      data () {
        return {
          loginAcc: this.$route.query.acc,
          linkName: this.$route.query.name,
          linkId: this.$route.query.id,
          editPwdShow: false
        }
      },
      created: function () {
      },
      methods: {
        queryDeviceList () {
          var _this = this
          var params = {
            deviceCode: _this.deviceCode
          }
          $axios.get('/third/queryDeviceByCode', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              if (res.resultData && res.resultData.list.length > 0) {
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  _this.code = itemData.deviceCode
                  _this.deviceModel = itemData.deviceModel
                  _this.paperNum = itemData.paperNum
                  _this.electricType = '电源适配器'
                  _this.supplementNum = itemData.supplementNum
                  _this.paperVolume = itemData.paperVolume
                  _this.uuid = itemData.uuid
                  _this.sysVersion = itemData.sysVersion
                  _this.appVersion = itemData.appVersion
                  _this.alias = itemData.alias
                  _this.ownerType = itemData.ownerType
                  _this.ownerName = _this.getDeviceSpaceValue(_this.LocationOptions, itemData.ownerType)
                  _this.longitude = itemData.longitude
                  _this.latitude = itemData.latitude
                  if (_this.latitude !== '0.0') {
                    _this.markers[0].position = [_this.longitude, _this.latitude]
                    _this.mapCenter = [_this.longitude, _this.latitude]
                  }
                  _this.address1 = itemData.address.split('|')[0]
                  _this.address2 = itemData.address.split('|')[1]
                  _this.getOwnerType()
                }
              }
            } else {
            }
          }, function () {
          })
        },
        changePwd () {
          this.editPwdShow = true
        },
        closeEditPwd () {
          this.editPwdShow = false
        },
        returnBack () {
          this.$router.back(-1)
        }
      },
      components: {
        'pu-edit-pwd': puEditPwd
      }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/page/accountMgr/editPwd.vue